// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.markdown-index > h1 {\n  font-size: 1.75em;\n  font-weight: 600;\n  margin: 04px 0 16px;\n  padding-bottom: 0.3em;\n  border-bottom: 1px solid #eaeaea;\n}\n.markdown-index > h2 {\n  font-size: 1.5em;\n  font-weight: 600;\n  margin: 24px 0 16px;\n  padding-bottom: 0.3em;\n  border-bottom: 1px solid #eaeaea;\n}\n", ""]);
// Exports
module.exports = exports;
